export default __webpack_public_path__ + "static/media/gp-grey.ecee0270.svg";